(() => {
  const requests = (window.libaseProductReviewRequests ||= new Map());
  window.libaseLoadProductReviews ||= (handle) => {
    if (!handle) return Promise.reject(new Error('missing_review_product'));
    const url = `https://libase-gacha.onrender.com/reviews?productId=${encodeURIComponent(handle)}`;
    if (!requests.has(url)) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      const request = fetch(url, { credentials: 'omit', cache: 'no-store', signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error('review_request_failed');
          return response.json();
        })
        .then((data) => {
          if (data?.ok !== true || !Array.isArray(data.reviews)) throw new Error('invalid_reviews');
          const reviews = data.reviews.filter((review) => {
            const rawRating = review?.rating;
            if (typeof rawRating !== 'number' && typeof rawRating !== 'string') return false;
            if (typeof rawRating === 'string' && !rawRating.trim()) return false;
            const rating = Number(rawRating);
            return Number.isFinite(rating) && rating >= 1 && rating <= 5;
          });
          const count = reviews.length;
          const average = count
            ? reviews.reduce((total, review) => total + Number(review.rating), 0) / count
            : null;
          return { ...data, reviews, summary: { count, avg: average } };
        })
        .finally(() => window.clearTimeout(timeout));
      requests.set(url, request);
      request.catch(() => requests.delete(url));
    }
    return requests.get(url);
  };

  if (customElements.get('libase-review-summary')) return;
  customElements.define('libase-review-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      const label = this.querySelector('[data-review-label]');
      const stars = this.querySelector('[data-review-stars]');
      const fill = this.querySelector('[data-review-fill]');
      const link = this.querySelector('a');
      if (!label || !stars || !fill || !link) return;
      this.loaded = true;

      const hideRating = () => {
        stars.hidden = true;
        fill.style.width = '0%';
        link.removeAttribute('aria-label');
      };
      hideRating();
      this.setAttribute('aria-busy', 'true');
      label.textContent = this.dataset.reviewLoading || this.dataset.reviewLink;

      window.libaseLoadProductReviews(this.dataset.productHandle)
        .then((data) => {
          const { count, avg: average } = data.summary;
          if (count === 0) {
            hideRating();
            label.textContent = this.dataset.reviewEmpty;
            return;
          }
          const displayAverage = average.toFixed(1);
          const format = (template) => template
            .replaceAll('__rating__', displayAverage)
            .replaceAll('__count__', String(count));
          fill.style.width = `${average / 5 * 100}%`;
          label.textContent = format(this.dataset.reviewFormat);
          link.setAttribute('aria-label', format(this.dataset.reviewAccessibleFormat));
          stars.hidden = false;
        })
        .catch(() => {
          hideRating();
          label.textContent = this.dataset.reviewLink;
        })
        .finally(() => this.setAttribute('aria-busy', 'false'));
    }
  });
})();
